<template>
  <div>
      <div class="top">
        <div class="box1">
          <div>{{ $t('menu.zcmxlsh') }}</div>
          <div>{{ mation.applyingDealerName }}</div>
        </div>
        <div class="box1">
          <div>{{ $t('menu.zckczt') }}</div>

          <div v-if="mation.status==0">{{ $t('menu.PendingReview') }}</div>
           <div v-if="mation.status==1">{{ $t('menu.yjcll') }}</div>
            <div v-if="mation.status==2">{{ $t('menu.Cancelled') }}</div>
        </div>
        <div class="box1">
          <div>{{ $t('menu.ApplicationTime') }}</div>
          <div>{{ mation.applyingDate }}</div>
        </div> 
        <div class="box1">
          <div>{{ $t('menu.clstme') }}</div>
          <div>{{ mation.approvingDate }}</div>
        </div>
      </div>
      <div class="zhong">
        {{ $t('menu.clmxl') }}
      </div>
        <el-table
      :data="mation.woParts"
      border
      style="width: 100%">
      <el-table-column
        prop="motorName"
        :label="$t('menu.zcmxcx')"
        width="180">
      </el-table-column>
      <el-table-column
        prop="vin"
       :label="$t('menu.FrameNumber')"
        width="180">
      </el-table-column>
      <el-table-column
        prop="currentWarrantyExpiry"
        :label="$t('menu.dqzbsj')">
      </el-table-column>
      <el-table-column
        prop="extendedWarrantyYear"
        :label="$t('menu.ycnx')">
      </el-table-column>
      <el-table-column
        prop="extendedWarrantyExpiry"
       :label="$t('menu.ychdqsj')">
      </el-table-column>
      <el-table-column
        prop="imageData"
        :label="$t('menu.yczbpoz')">
       <template slot-scope="scope">
        <div v-for="(item,index) in scope.row.imageData" :key="index" @click="djxz(item)" style="cursor: pointer;">
          {{ item.name }}
        </div>
        </template>

      </el-table-column>
      <el-table-column
      v-if="shenfen=='1'"
        prop="id"
        :label="$t('menu.zckczt')">
        <template slot-scope="scope">
        
           <el-select v-model="scope.row.status" v-if="mation.status==0" placeholder="请选择">
             <el-option :label="$t('menu.Approved')" :value="1"> </el-option>
             <el-option :label="$t('menu.Rejected')" :value="2"> </el-option>
          
            </el-select> 
            <el-select v-model="scope.row.status" v-else disabled placeholder="请选择">
             <el-option :label="$t('menu.Approved')" :value="1"> </el-option>
             <el-option :label="$t('menu.Rejected')" :value="2"> </el-option>
          
            </el-select>
        </template>
      </el-table-column>
    </el-table>
    <div  v-if="shenfen=='1'&&mation.status==0" style="margin-top: 30px;display: flex;">
      <el-button type="primary" @click="put">{{ $t('menu.Submitsuopei') }}</el-button>
       <el-button @click="quxiao">{{ $t('menu.Cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
import { woOfDealercont,woOfDealerlist,putDealercont,upload } from "../../api/api";

export default {
  data () {
    return {
      id:'',
      shenfen:'',
      mation: {
        applyingDealerName:'',
        status:'',
        applyingDate:'',
      }, //列表
      
    };
  },
  created () {
     this.shenfen=sessionStorage.getItem("platform")//0:运营平台 , 1:经销商平台 , 2:零售商平台
    this.id=this.$route.query.id
    this.biao();
 
  },
 
  
  methods: {
 
    async put(){
      
      let param=this.mation
      param.woParts.forEach((e,i)=>{
        if( e.imageData!==undefined&& e.imageData!==null)
  
       
        
       param.woParts[i].imageData=JSON.stringify(e.imageData)
      })
      console.log(12,JSON.parse(JSON.stringify(param)));
       param.status=1
      const { data: res } = await putDealercont( param);
      console.log(res);
      
      if(res.code==500){
         this.$message.error(res.msg)
          param.status=0
      }else{
         this.$message.success(this.$t('menu.caozuochengong'))
         this.$router.push('/Guarantee')
           param.status=1
      }
     
   
    },
    async quxiao(){
        
      let param=this.mation
     param.status=2
      const { data: res } = await putDealercont(  param );
      console.log(res);
      
      if(res.code==500){
         this.$message.error(res.msg)
          param.status=0
      }else{
           param.status=2
         this.$message.success('取消成功')
            this.$router.push('/Guarantee')
      }
   
    },
    djxz(e){
      let link = document.createElement("a");

      link.href = e.url;

      link.setAttribute("download",e.name);

      link.click();

      link.remove();
    },
    async biao () {
    
      let param = new URLSearchParams();
     
      const { data: res } = await woOfDealercont(
        param,
        this.id
      );
       this.mation = res.data;
      res.data.woParts.forEach((e,i)=>{
        if( e.imageData!==undefined&& e.imageData!==null)
  
        console.log(123123,JSON.parse(e.imageData));
        
        this.mation.woParts[i].imageData=JSON.parse(e.imageData)
      })
     
   
      

    
      // let param = new URLSearchParams();
      // let orderNumber = ''
      // let applyingDealerId = ''
     
      // let status = ''
     
      // const { data: res } = await woOfDealerlist(
      //   param,
      //   orderNumber,
      //    1,
      //    10,
      //    applyingDealerId,
      //   status
      // );

      // this.mation = res.rows[0];
     
    
    
    
    },
  
 
  }

};
</script>

<style lang="less" scoped>
.top{
  display: flex;
  flex-wrap: wrap;
  font-size: 20px;
}
.box1{
  width: 33%;
  margin-bottom: 40px;
  line-height: 45px;
}
.zhong{
  font-size: 20px;
  line-height: 45px;
  border-bottom: 1px solid #00000033;
}
</style>